import { FONT_SIZE_BASE } from '../theme/constants';
export const convertRemToPx = (rem) => parseInt(String(parseFloat(String(rem)) * FONT_SIZE_BASE), 10);
//# sourceMappingURL=convertRemToPx.js.map